export const ENABLE_SETTINGS_COM_CALL = false
export const ENABLE_SETTINGS_COM_SMS = false
